<template>
	<v-card class="mx-auto search-block-card" elevation="0">
		<v-toolbar
			color="#2D4B95"
			dark
			dense
			height="36px"
			v-if="hasResults"
		>
			<v-toolbar-title class="caption toolbar-title">
				Hemos encontrado elementos similares. Revísalos para evitar duplicados.
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon small @click="closeResults()">
				<v-icon size="18">mdi-close-circle-outline</v-icon>
			</v-btn>
		</v-toolbar>

		<v-tabs
			v-if="hasResults"
			v-model="tab"
			fixed-tabs
			color="#2D4B95"
			height="32px"
			class="search-tabs"
		>
			<v-tab v-if="searchResult.tasks && searchResult.tasks.length > 0" class="caption tab-label">
				Tareas
				<span class="tab-count ml-1">{{ searchResult.tasks.length }}</span>
			</v-tab>
			<v-tab v-if="searchResult.rdis && searchResult.rdis.length > 0" class="caption tab-label">
				RDI
				<span class="tab-count ml-1">{{ searchResult.rdis.length }}</span>
			</v-tab>
		</v-tabs>

		<div class="results-scroll" v-if="hasResults">
			<v-tabs-items v-model="tab">

				<!-- TAREAS -->
				<v-tab-item v-if="searchResult.tasks && searchResult.tasks.length > 0">
					<v-list dense class="py-0">
						<v-list-item
							v-for="(tarea, index) in searchResult.tasks"
							:key="'task-' + index"
							@click="viewTarea(tarea.id, $options.filters.seenByMe(tarea.seen_by_me))"
							class="result-item"
						>
							<!-- Izquierda: estrella + badge número -->
							<div class="item-left">
								<svg
									v-if="tarea.status == 3"
									class="star-icon"
									width="13"
									height="13"
									viewBox="0 0 24 24"
									fill="#16a34a"
								>
									<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
								</svg>
								<span v-else class="star-placeholder"></span>
								<div class="number-badge caption">{{ tarea.number }}</div>
							</div>

							<!-- Centro: título + descripción -->
							<div class="item-content">
								<p class="item-title caption mb-0">{{ tarea.title }}</p>
								<p class="item-desc caption mb-0">
									<span v-html="tarea.description"></span>
								</p>
							</div>

							<!-- Derecha: flecha -->
							<v-icon size="18" color="grey lighten-1" class="flex-shrink-0">
								mdi-chevron-right
							</v-icon>
						</v-list-item>
					</v-list>
				</v-tab-item>

				<!-- RDI -->
				<v-tab-item v-if="searchResult.rdis && searchResult.rdis.length > 0">
					<v-list dense class="py-0">
						<v-list-item
							v-for="(rdi, index) in searchResult.rdis"
							:key="'rdi-' + index"
							@click="viewRDI(rdi.id)"
							class="result-item"
						>
							<!-- Izquierda: estrella + badge número -->
							<div class="item-left">
								<svg
									v-if="rdi.status == 3"
									class="star-icon"
									width="13"
									height="13"
									viewBox="0 0 24 24"
									fill="#16a34a"
								>
									<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
								</svg>
								<span v-else class="star-placeholder"></span>
								<div class="number-badge caption">{{ rdi.number }}</div>
							</div>

							<!-- Centro: título + descripción -->
							<div class="item-content">
								<p class="item-title caption mb-0">{{ rdi.title }}</p>
								<p class="item-desc caption mb-0">
									<span v-html="rdi.description"></span>
								</p>
							</div>

							<!-- Derecha: flecha -->
							<v-icon size="18" color="grey lighten-1" class="flex-shrink-0">
								mdi-chevron-right
							</v-icon>
						</v-list-item>
					</v-list>
				</v-tab-item>

			</v-tabs-items>
		</div>
	</v-card>
</template>

<script>
import {getTareaByID} from '@/helpers/api/tasks'
import {getRdiByID} from '@/helpers/api/rdi'

export default {
	name: 'SearchBlockForms',
	props: {
		closeResults: {
			type: Function
		},
		searchResult: {
			type: Object,
			default: () => ({ tasks: [], rdis: [], additionals: [] })
		},
		searching: {
			type: Boolean,
			default: true
		}
	},
	data: () => ({
		tab: null
	}),
	computed: {
		hasResults() {
			return (
				(this.searchResult.tasks && this.searchResult.tasks.length > 0) ||
				(this.searchResult.rdis && this.searchResult.rdis.length > 0) ||
				(this.searchResult.additionals && this.searchResult.additionals.length > 0)
			)
		}
	},
	methods: {
		async viewTarea(task_id, seen_by_me) {
			this.$store.consultasStore.commit('setCurrentTarea', { loading: true })
			const tarea = await getTareaByID({ task_id })
			if (tarea.code === 200) {
				let tareaData = tarea.task
				tareaData.prev_seen_by_me = seen_by_me
				this.$store.consultasStore.commit('setCurrentTarea', tareaData)
			}
		},
		async viewRDI(rdi_id) {
			this.$store.rdiStore.commit('setCurrentRDI', { loading: true })
			const rdi = await getRdiByID({ rdi_id })
			if (rdi.code === 200) {
				let rdiData = rdi.rdi
				rdiData.prev_seen_by_me = false
				this.$store.rdiStore.commit('setCurrentRDI', rdiData)
			}
		}
	}
}
</script>

<style scoped>
/* Card base */
.search-block-card {
	border: 1px solid #e0e0e0;
	border-radius: 6px;
	overflow: hidden;
}

/* Toolbar */
.toolbar-title {
	font-size: 11px !important;
	line-height: 1.3;
	white-space: normal;
}

/* Tabs */
.search-tabs {
	border-bottom: 1px solid #e8e8e8;
}
.tab-label {
	font-size: 11px !important;
	text-transform: none;
	letter-spacing: 0;
}
.tab-count {
	background-color: #e8edf7;
	color: #2D4B95;
	border-radius: 10px;
	padding: 0 5px;
	font-size: 10px;
	font-weight: 600;
	line-height: 16px;
}

/* Scroll container */
.results-scroll {
	max-height: 360px;
	overflow-y: auto;
}

/* Cada ítem de resultado */
.result-item {
	display: flex !important;
	flex-direction: row !important;
	align-items: center !important;
	gap: 8px;
	padding: 7px 12px !important;
	min-height: 0 !important;
	border-bottom: 1px solid #f0f0f0;
	cursor: pointer;
	transition: background-color 0.12s ease;
}
.result-item:last-child {
	border-bottom: none;
}
.result-item:hover {
	background-color: #f5f7fb;
}

/* Columna izquierda: estrella + badge */
.item-left {
	display: flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
}
.star-icon {
	flex-shrink: 0;
}
.star-placeholder {
	display: inline-block;
	width: 13px;
	flex-shrink: 0;
}
.number-badge {
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background-color: #2D4B95;
	color: #fff;
	font-size: 10px !important;
	font-weight: 600;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	line-height: 1;
}

/* Columna central: título + descripción */
.item-content {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 1px;
}
.item-title {
	font-size: 12px !important;
	font-weight: 600;
	color: #333;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.4;
}
.item-desc {
	font-size: 11px !important;
	color: #888;
	line-height: 1.3;
	max-height: 1.3em;
	overflow: hidden;
}
.item-desc /deep/ * {
	display: inline;
	white-space: nowrap;
}
.item-desc /deep/ p,
.item-desc /deep/ div,
.item-desc /deep/ br {
	display: none;
}
.item-desc /deep/ p:first-child,
.item-desc /deep/ div:first-child {
	display: inline;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
}

/* Flecha derecha */
.flex-shrink-0 {
	flex-shrink: 0;
}
</style>